<style lang="scss" scoped>
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.tip-item {
    width: 100%;
    margin: 10px 0px;
    .tip-p {
        color: #ed4014;
        p {
            line-height: 23px;
        }
    }
}
</style>
<template>
    <div>
        <vTableSimple
            style="max-height: 200px; overflow: auto"
            class="margin-top-10"
            :columns="columns"
            :data="dataList"
        ></vTableSimple>
        <!-- <span style="display:inline-block;line-height:31px;margin-left:10px" class="color-error" v-html="$t('erp.distribution.buyLabel',{defaultValue:'购买面单'})">{{$t('erp.distribution.buyLabel',{defaultValue:'购买面单'})}}</span> -->
        <div class="tip-item">
            <div
                class="tip-p"
                v-html="
                    $t('erp.distribution.buyLabel', {
                        defaultValue: '购买面单',
                    })
                "
            ></div>
        </div>
        <div
            style="
                padding: 12px 0px;
                margin-bottom: -6px;
                border-top: 1px solid #e8eaec;
            "
            class="text-right"
        >
            <vButton @click="confirm" theme="primary">{{
                $t("global.common.update_OK", { defaultValue: "确定" })
            }}</vButton>
        </div>
        <vLoading size="large" transfer :loading="loading">
            <Icon
                type="ios-loading"
                size="18"
                class="demo-spin-icon-load"
            ></Icon>
            <div>
                {{
                    $t("erp.b2c.buying_in_progress", { defaultValue: "购买中" })
                }}
            </div>
        </vLoading>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { HttpBuyLabel } from "@/service/boss/distribution";

export default {
    props: ["activeids", "res"],
    data() {
        return {
            loading: false,
            dataList: [],
            checkedData: "",
            deliverOrderId: "",
        };
    },
    created() {
        this.getDetail();
    },
    computed: {
        ...mapState([""]),
        columns() {
            return [
                {
                    width: 60,
                    align: "center",
                    render: (h, { row }) => {
                        return h("Radio", {
                            props: {
                                value:
                                    this.checkedData === row.carrierServiceCode,
                            },
                            on: {
                                input: () => {
                                    this.handleCheckData(
                                        row.carrierServiceCode
                                    );
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    render: (h, { row }) => {
                        return row.carrierServiceCode || "--";
                    },
                },
                {
                    title: this.$t("erp.b2c.estimated_cost", {
                        defaultValue: "预估费用",
                    }),
                    key: "totalCustomerCost",
                    render: (h, { row }) => {
                        return row.totalCustomerCost || "--";
                    },
                },
                {
                    title: this.$t("global.common.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                    render: (h, { row }) => {
                        return row.currency || "--";
                    },
                },
            ];
        },
    },
    methods: {
        handleCheckData(val) {
            this.checkedData = val;
        },
        getDetail() {
            this.dataList = this.res.data;
            this.deliverOrderId = this.activeids;
        },
        async confirm() {
            if (!this.checkedData) {
                this.$VMessage.error(
                    this.$t("erp.b2c.please_choose_one_option", {
                        defaultValue: "请选择一项",
                    })
                );
                return;
            }
            this.loading = true;
            await HttpBuyLabel({
                deliverOrderId: this.deliverOrderId,
                carrierServiceCode: this.checkedData,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>
